// extracted by mini-css-extract-plugin
export default {"wrapper":"EventumCnRedirectButton_wrapper","withIcon":"EventumCnRedirectButton_withIcon"};